// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/deal.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bfftypes/v1/deal.proto.
 */
export const file_bfftypes_v1_deal: GenFile = /*@__PURE__*/
  fileDesc("ChZiZmZ0eXBlcy92MS9kZWFsLnByb3RvEgtiZmZ0eXBlcy52MSJNChJEZWFsUG9zaXRpb25PcHRpb24SKAoFdmFsdWUYASABKA4yGS5iZmZ0eXBlcy52MS5EZWFsUG9zaXRpb24SDQoFbGFiZWwYAiABKAkqXQoMRGVhbFBvc2l0aW9uEh0KGURFQUxfUE9TSVRJT05fVU5TUEVDSUZJRUQQABIVChFERUFMX1BPU0lUSU9OX0JJRBABEhcKE0RFQUxfUE9TSVRJT05fT0ZGRVIQAipnCgpTcHJlYWRUeXBlEhsKF1NQUkVBRF9UWVBFX1VOU1BFQ0lGSUVEEAASGwoXU1BSRUFEX1RZUEVfU1BSRUFEX0JBU0UQARIfChtTUFJFQURfVFlQRV9TUFJFQURfRVhDSEFOR0UQAipWChFQcm9kdWN0U3ByZWFkVHlwZRIjCh9QUk9EVUNUX1NQUkVBRF9UWVBFX1VOU1BFQ0lGSUVEEAASHAoYUFJPRFVDVF9TUFJFQURfVFlQRV9BUkVBEAEqsgEKFERlYWxTdWJtaXNzaW9uU291cmNlEiYKIkRFQUxfU1VCTUlTU0lPTl9TT1VSQ0VfVU5TUEVDSUZJRUQQABIjCh9ERUFMX1NVQk1JU1NJT05fU09VUkNFX0VORUNIQUlOEAESJwojREVBTF9TVUJNSVNTSU9OX1NPVVJDRV9PVEhFUl9CUk9LRVIQAhIkCiBERUFMX1NVQk1JU1NJT05fU09VUkNFX0JJTEFURVJBTBADKowBCgxEZWxpdmVyeVR5cGUSHQoZREVMSVZFUllfVFlQRV9VTlNQRUNJRklFRBAAEhQKEERFTElWRVJZX1RZUEVfQkcQARIWChJERUxJVkVSWV9UWVBFX0pFUFgQAhIVChFERUxJVkVSWV9UWVBFX0VFWBADIgQIBBAEKhJERUxJVkVSWV9UWVBFX1NXQVAqlQEKEERlbGl2ZXJ5SG91clR5cGUSIgoeREVMSVZFUllfSE9VUl9UWVBFX1VOU1BFQ0lGSUVEEAASGwoXREVMSVZFUllfSE9VUl9UWVBFX0JBU0UQARIdChlERUxJVkVSWV9IT1VSX1RZUEVfTUlERExFEAIiBAgDEAMqG0RFTElWRVJZX0hPVVJfVFlQRV9PRkZfUEVBSyr4AgoSRGVsaXZlcnlQZXJpb2RUeXBlEiQKIERFTElWRVJZX1BFUklPRF9UWVBFX1VOU1BFQ0lGSUVEEAASHgoaREVMSVZFUllfUEVSSU9EX1RZUEVfTU9OVEgQBBIgChxERUxJVkVSWV9QRVJJT0RfVFlQRV9RVUFSVEVSEAUSHwobREVMSVZFUllfUEVSSU9EX1RZUEVfU0VBU09OEAYSJAogREVMSVZFUllfUEVSSU9EX1RZUEVfRklTQ0FMX1lFQVIQCBIkCiBERUxJVkVSWV9QRVJJT0RfVFlQRV9NVUxUSV9NT05USBAJIgQIARABIgQIAhACIgQIAxADIgQIBxAHKhhERUxJVkVSWV9QRVJJT0RfVFlQRV9EQVkqGURFTElWRVJZX1BFUklPRF9UWVBFX1dFRUsqHERFTElWRVJZX1BFUklPRF9UWVBFX1dFRUtFTkQqIkRFTElWRVJZX1BFUklPRF9UWVBFX0NBTEVOREFSX1lFQVJCsAEKD2NvbS5iZmZ0eXBlcy52MUIJRGVhbFByb3RvUAFaRWdpdGh1Yi5jb20vZW5lY2hhaW4vZXBvc2l0aW9uLWFwcC9iYWNrZW5kL2dlbi9wcm90by9iZmZ0eXBlcy92MTt0eXBlc6ICA0JYWKoCC0JmZnR5cGVzLlYxygILQmZmdHlwZXNcVjHiAhdCZmZ0eXBlc1xWMVxHUEJNZXRhZGF0YeoCDEJmZnR5cGVzOjpWMWIGcHJvdG8z");

/**
 * @generated from message bfftypes.v1.DealPositionOption
 */
export type DealPositionOption = Message<"bfftypes.v1.DealPositionOption"> & {
  /**
   * @generated from field: bfftypes.v1.DealPosition value = 1;
   */
  value: DealPosition;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message bfftypes.v1.DealPositionOption.
 * Use `create(DealPositionOptionSchema)` to create a new message.
 */
export const DealPositionOptionSchema: GenMessage<DealPositionOption> = /*@__PURE__*/
  messageDesc(file_bfftypes_v1_deal, 0);

/**
 * @generated from enum bfftypes.v1.DealPosition
 */
export enum DealPosition {
  /**
   * @generated from enum value: DEAL_POSITION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 買
   *
   * @generated from enum value: DEAL_POSITION_BID = 1;
   */
  BID = 1,

  /**
   * 売
   *
   * @generated from enum value: DEAL_POSITION_OFFER = 2;
   */
  OFFER = 2,
}

/**
 * Describes the enum bfftypes.v1.DealPosition.
 */
export const DealPositionSchema: GenEnum<DealPosition> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_deal, 0);

/**
 * @generated from enum bfftypes.v1.SpreadType
 */
export enum SpreadType {
  /**
   * @generated from enum value: SPREAD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * スプレッド基準側
   *
   * @generated from enum value: SPREAD_TYPE_SPREAD_BASE = 1;
   */
  SPREAD_BASE = 1,

  /**
   * スプレッド交換側
   *
   * @generated from enum value: SPREAD_TYPE_SPREAD_EXCHANGE = 2;
   */
  SPREAD_EXCHANGE = 2,
}

/**
 * Describes the enum bfftypes.v1.SpreadType.
 */
export const SpreadTypeSchema: GenEnum<SpreadType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_deal, 1);

/**
 * @generated from enum bfftypes.v1.ProductSpreadType
 */
export enum ProductSpreadType {
  /**
   * @generated from enum value: PRODUCT_SPREAD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRODUCT_SPREAD_TYPE_AREA = 1;
   */
  AREA = 1,
}

/**
 * Describes the enum bfftypes.v1.ProductSpreadType.
 */
export const ProductSpreadTypeSchema: GenEnum<ProductSpreadType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_deal, 2);

/**
 * @generated from enum bfftypes.v1.DealSubmissionSource
 */
export enum DealSubmissionSource {
  /**
   * @generated from enum value: DEAL_SUBMISSION_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * enechain経由
   *
   * @generated from enum value: DEAL_SUBMISSION_SOURCE_ENECHAIN = 1;
   */
  ENECHAIN = 1,

  /**
   * 他broker経由
   *
   * @generated from enum value: DEAL_SUBMISSION_SOURCE_OTHER_BROKER = 2;
   */
  OTHER_BROKER = 2,

  /**
   * 相対取引
   *
   * @generated from enum value: DEAL_SUBMISSION_SOURCE_BILATERAL = 3;
   */
  BILATERAL = 3,
}

/**
 * Describes the enum bfftypes.v1.DealSubmissionSource.
 */
export const DealSubmissionSourceSchema: GenEnum<DealSubmissionSource> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_deal, 3);

/**
 * @generated from enum bfftypes.v1.DeliveryType
 */
export enum DeliveryType {
  /**
   * @generated from enum value: DELIVERY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DELIVERY_TYPE_BG = 1;
   */
  BG = 1,

  /**
   * @generated from enum value: DELIVERY_TYPE_JEPX = 2;
   */
  JEPX = 2,

  /**
   * @generated from enum value: DELIVERY_TYPE_EEX = 3;
   */
  EEX = 3,
}

/**
 * Describes the enum bfftypes.v1.DeliveryType.
 */
export const DeliveryTypeSchema: GenEnum<DeliveryType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_deal, 4);

/**
 * @generated from enum bfftypes.v1.DeliveryHourType
 */
export enum DeliveryHourType {
  /**
   * @generated from enum value: DELIVERY_HOUR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DELIVERY_HOUR_TYPE_BASE = 1;
   */
  BASE = 1,

  /**
   * @generated from enum value: DELIVERY_HOUR_TYPE_MIDDLE = 2;
   */
  MIDDLE = 2,
}

/**
 * Describes the enum bfftypes.v1.DeliveryHourType.
 */
export const DeliveryHourTypeSchema: GenEnum<DeliveryHourType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_deal, 5);

/**
 * @generated from enum bfftypes.v1.DeliveryPeriodType
 */
export enum DeliveryPeriodType {
  /**
   * @generated from enum value: DELIVERY_PERIOD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DELIVERY_PERIOD_TYPE_MONTH = 4;
   */
  MONTH = 4,

  /**
   * @generated from enum value: DELIVERY_PERIOD_TYPE_QUARTER = 5;
   */
  QUARTER = 5,

  /**
   * @generated from enum value: DELIVERY_PERIOD_TYPE_SEASON = 6;
   */
  SEASON = 6,

  /**
   * @generated from enum value: DELIVERY_PERIOD_TYPE_FISCAL_YEAR = 8;
   */
  FISCAL_YEAR = 8,

  /**
   * @generated from enum value: DELIVERY_PERIOD_TYPE_MULTI_MONTH = 9;
   */
  MULTI_MONTH = 9,
}

/**
 * Describes the enum bfftypes.v1.DeliveryPeriodType.
 */
export const DeliveryPeriodTypeSchema: GenEnum<DeliveryPeriodType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_deal, 6);

